/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-24
 * @brief EHP 설비수명 - 수명인자 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
// component
import EhpPagination from "../../common/pagination/EhpPagination";
import { loadingBoxState } from "../../../recoil/menuState";
import { useTrans } from "../../../utils/langs/useTrans";
import { useNavigate } from "react-router-dom";
/**
* @brief EHP 설비수명  - 수명인자 List 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
function DeviceLifeList(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const isMobile = props.isMobile;
    const selTree = props.selTree;
    const workMode = props.workMode;
    const setParentIsMobile = props.setIsMobile;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const reWork = props.reWork;
    const setReWork = props.setReWork;
    // by hjo - 20220920 - 추가 hook
    const setListWork = props.setListWork;
    const setNodata = props.setNodata;
    const setListItem = props.setListItem;
    const restart = props.restart;
    const setRestart = props.setRestart;
    const [list, setList] = useState([]);
    //페이지
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    const searchFieldList = [
        //{"id":0, "sfDisp":"전체", "sfVal":""},
        { "id": 1, "sfDisp": t("FIELD.기기명"), "sfVal": "spgName" },
        { "id": 2, "sfDisp": t("FIELD.Panel명"), "sfVal": "panelName" },
        { "id": 3, "sfDisp": t("FIELD.시리얼번호"), "sfVal": "serialNo" },
        { "id": 3, "sfDisp": t("FIELD.모델명"), "sfVal": "modelName" },
    ];
    const [searchField, setSearchField] = useState(searchFieldList[0]);
    const [searchText, setSearchText] = useState("");
    const [searchData, setSearchData] = useState({
        "searchField": null,
        "searchText": null,
    });
    const [fieldList, setFieldList] = useState([
        { "id": 0, "fdDisp": "상태", "fdVal": "deviceLifeSet", "sort": "asc", "click": false },
        { "id": 1, "fdDisp": "등록순", "fdVal": "rowNumber", "sort": "asc", "click": false },
        { "id": 2, "fdDisp": "기기명", "fdVal": "spgName", "sort": "asc", "click": false },
        { "id": 3, "fdDisp": "Panel 명", "fdVal": "panelName", "sort": "asc", "click": false },
        { "id": 4, "fdDisp": "모델 명", "fdVal": "itemName", "sort": "asc", "click": false },
        { "id": 5, "fdDisp": "시리얼 번호", "fdVal": "serialNo", "sort": "asc", "click": false },
        { "id": 6, "fdDisp": "정격전압", "fdVal": "ratingVoltage", "sort": "asc", "click": false },
        { "id": 7, "fdDisp": "Basic", "fdVal": null, "sort": "asc", "click": false },
        { "id": 8, "fdDisp": "Premium", "fdVal": null, "sort": "asc", "click": false },
        { "id": 9, "fdDisp": "Advanced", "fdVal": null, "sort": "asc", "click": false },
    ]);
    let appPath = selTree.room.roomId;
    // device List API
    appPath = appPath + '&page=' + pageInfo.number + '&size=' + pageInfo.size;
    // // sort
    // appPath = appPath + '&sort=' + sortData.sortField + ',' + sortData.sort;
    //text검색
    if (searchData.searchField) {
        if (searchData.searchField.sfVal.length > 0) {
            appPath = appPath + `&searchKind=${searchData.searchField.sfVal}&searchLike=${searchData.searchText}`;
        }
    }
    //필드 정렬
    fieldList.filter(fd => fd.click && fd.sort).map((fd) => {
        appPath = appPath + `&sort=${fd.fdVal},${fd.sort}`;
    });
    const { data: resInfo, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/devicelifelist?roomId=${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + selTree.reload
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, resInfo);
        //clog("IN TREE : RESLT CHECK : " + ERR_URL + " : " + isLoading + " : " + JSON.stringify(resInfo));
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (resInfo /* !isLoading */) {
            if (resInfo.codeNum == CONST.API_200) {
                setList(resInfo.body);
                setPageInfo(Object.assign(Object.assign({}, resInfo.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
                // setUserTree(resInfo.body);
            }
            else {
                alert(resInfo.errorList.map((err) => (err.msg)));
            }
        }
    }, [resInfo]);
    // option 선택 시  값 변경 액션
    function selectOptionSearchField(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        var sf = JSON.parse(optionData);
        if (sf.sfVal.length <= 0)
            setSearchText("");
        setSearchField(JSON.parse(optionData));
        //
    }
    function onClickSearch(e) {
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        setSearchData({
            "searchField": searchField,
            "searchText": searchText,
        });
        handleCurPage(0);
    }
    function onClickSortField(fieldVal) {
        setFieldList(fieldList.map(fd => (fd.fdVal === fieldVal)
            ? Object.assign(Object.assign({}, fd), { "sort": (fd.sort === "asc") ? "desc" : "asc", "click": true }) : Object.assign(Object.assign({}, fd), { "sort": "asc", "click": false })) // 단일 필드 정렬만....
        );
    }
    useEffect(() => {
        setNodata(pageInfo.totalElements);
        if (reWork.room.roomId != selTree.room.roomId) {
            setSearchText("");
            setSearchData({
                searchField: "",
                searchText: ""
            });
            setFieldList(fieldList.map(fd => (fd.fdVal === fieldList[1].fdVal)
                ? Object.assign(Object.assign({}, fd), { "sort": (fd.sort === "desc") ? "desc" : "asc", "click": true }) : Object.assign(Object.assign({}, fd), { "sort": "asc", "click": false })) // 단일 필드 정렬만....
            );
            handleCurPage(0);
        }
    }, [pageInfo.totalElements, reWork.room.roomId, selTree.room.roomId]);
    function updataClick(e, list) {
        setListItem(list);
        setParentWorkMode("UPDATE");
    }
    // 
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right" },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, selTree.company.companyName),
                React.createElement("li", null, selTree.zone.zoneName),
                React.createElement("li", null, selTree.subZone.subZoneName),
                React.createElement("li", null, selTree.room.roomName)),
            React.createElement("h2", null, selTree.room.roomName),
            React.createElement("div", { className: "inline mb-18" },
                React.createElement("a", { href: "#", className: "move-list active" }, "Device List"),
                React.createElement("a", { href: "#", className: "move-list" }, t("LABEL.수명인자설정"))),
            React.createElement("div", { className: "area__right_content hcal-170" },
                React.createElement("div", { className: "inline right search-small mb-16 p-0" },
                    React.createElement("p", { className: "title" },
                        React.createElement("span", { className: "txt-black" }, t("LABEL.검색"))),
                    React.createElement("div", { className: "searcharea" },
                        React.createElement("div", { className: "searchinput" },
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSearchField) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, searchFieldList[0].sfDisp),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf) }, sf.sfDisp))))),
                            React.createElement("div", { className: "input__direct" },
                                React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, className: "w274", onChange: (e) => setSearchText(e.target.value) }),
                                (searchText.length > 0) && React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") },
                                    React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30"))),
                            React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickSearch(e) },
                                React.createElement("span", null, t("LABEL.조회")))))),
                React.createElement("p", { className: "nodata__txt " }, t("MESSAGE.데이터를찾을수없습니다")),
                React.createElement("div", { className: "tbl-list td-h26 hcal-130" },
                    React.createElement("table", { summary: "\uC0C1\uD0DC,\uB4F1\uB85D \uC21C,\uC124\uBE44 \uBA85,Panel \uBA85,\uBAA8\uB378 \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC815\uACA9\uC804\uC555,Basic,Premium,Advanced \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC124\uBE44\uC218\uBA85 \uC778\uC790\uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uC124\uBE44\uC218\uBA85 \uC778\uC790\uBAA9\uB85D"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "deviceLifeSet").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("deviceLifeSet") },
                                    React.createElement("span", null, t("FIELD.상태"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "rowNumber").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("rowNumber") },
                                    React.createElement("span", null, t("FIELD.등록순"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "spgName").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("spgName") },
                                    React.createElement("span", null, t("FIELD.기기명"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "panelName").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("panelName") },
                                    React.createElement("span", null, t("FIELD.Panel명"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "itemName").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("itemName") },
                                    React.createElement("span", null, t("FIELD.모델명"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "serialNo").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("serialNo") },
                                    React.createElement("span", null, t("FIELD.시리얼번호"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "ratingVoltage").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("ratingVoltage") },
                                    React.createElement("span", null, t("FIELD.정격전압"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "basicScore").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none` },
                                    React.createElement("span", null, t("Basic"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "premiumScore").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none` },
                                    React.createElement("span", null, t("Premium"))),
                                React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "advancedScore").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none` },
                                    React.createElement("span", null, t("Advanced"))))),
                        React.createElement("tbody", null, (list) && list.map((list, idx) => (React.createElement("tr", { key: "life_" + idx.toString(), onClick: (e) => updataClick(e, list) },
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("p", { className: `font-12 fontMedium ${(list.deviceLifeSet) ? "txt-blue" : "txt-gray"}` }, (list.deviceLifeSet) ? "설정완료" : "미설정")),
                            React.createElement("td", { className: "txt-left" }, (list.rowNumber ? list.rowNumber : "-")),
                            React.createElement("td", { className: "txt-left" }, (list.spg.spgName) ? list.spg.spgName : "-"),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("p", { className: "ellipsis w100p" }, (list.panel.panelName) ? list.panel.panelName : "")),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("p", { className: "ellipsis w100p" }, (list.modelName) ? list.modelName : "")),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("p", { className: "ellipsis w100p" }, (list.serialNo) ? list.serialNo : "-")),
                            React.createElement("td", { className: "txt-left" }, (list.ratingVoltage) ? list.ratingVoltage : "-"),
                            React.createElement("td", { className: "txt-left" }, (list.basicAssess.totalScore !== null) ? list.basicAssess.totalScore : "-"),
                            React.createElement("td", { className: "txt-left" }, (list.premiumAssess.totalScore !== null) ? list.premiumAssess.totalScore : "-"),
                            React.createElement("td", { className: "txt-left" }, (list.advancedAssess.totalScore !== null) ? list.advancedAssess.totalScore : "-"))))))),
                (pageInfo) && React.createElement(EhpPagination, { componentName: "WorkOrderInspection", pageInfo: pageInfo, handleFunc: handleCurPage })))));
}
export default DeviceLifeList;
